const PRODUCT_BREADCRUMB_STORAGE_KEY = 'tilray:product-breadcrumb-collection';

/**
 * @typedef {object} ProductBreadcrumbCollectionContext
 * @property {string} handle
 * @property {string} title
 * @property {string} url
 */

/** @returns {ProductBreadcrumbCollectionContext | null} */
function readStoredCollectionContext() {
  const storages = [window.sessionStorage, window.localStorage];

  for (const storage of storages) {
    try {
      const rawValue = storage.getItem(PRODUCT_BREADCRUMB_STORAGE_KEY);
      if (!rawValue) continue;

      const parsedValue = JSON.parse(rawValue);
      if (!parsedValue?.handle || !parsedValue?.title || !parsedValue?.url) {
        continue;
      }

      return parsedValue;
    } catch {}
  }

  return null;
}

class CustomProductBreadcrumb extends HTMLElement {
  connectedCallback() {
    this.renderCollectionCrumb();
  }

  /** @returns {ProductBreadcrumbCollectionContext[]} */
  get productCollections() {
    try {
      const parsedCollections = JSON.parse(this.dataset.productCollections || '[]');
      return Array.isArray(parsedCollections) ? parsedCollections : [];
    } catch {
      return [];
    }
  }

  renderCollectionCrumb() {
    const storedCollectionContext = readStoredCollectionContext();
    if (!storedCollectionContext) return;

    const matchingCollection = this.productCollections.find(
      (collection) => collection.handle === storedCollectionContext.handle
    );

    if (!matchingCollection) return;

    const collectionLink = this.querySelector('[data-breadcrumb-collection-link]');
    const collectionSeparator = this.querySelector('[data-breadcrumb-collection-separator]');

    if (!(collectionLink instanceof HTMLAnchorElement) || !(collectionSeparator instanceof HTMLElement)) {
      return;
    }

    collectionLink.textContent = storedCollectionContext.title || matchingCollection.title;
    collectionLink.href = storedCollectionContext.url || matchingCollection.url;
    collectionLink.hidden = false;
    collectionSeparator.hidden = false;
  }
}

if (!customElements.get('custom-product-breadcrumb')) {
  customElements.define('custom-product-breadcrumb', CustomProductBreadcrumb);
}